// extracted by mini-css-extract-plugin
module.exports = {"OfficeCard":"styles_OfficeCard__FkqIT","height":"styles_height__jERKh"};